var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3077 15.5C1.80257 15.5 1.375 15.325 1.025 14.975C0.675 14.625 0.5 14.1974 0.5 13.6923V2.3077C0.5 1.80257 0.675 1.375 1.025 1.025C1.375 0.675 1.80257 0.5 2.3077 0.5H17.6923C18.1974 0.5 18.625 0.675 18.975 1.025C19.325 1.375 19.5 1.80257 19.5 2.3077V13.6923C19.5 14.1974 19.325 14.625 18.975 14.975C18.625 15.325 18.1974 15.5 17.6923 15.5H2.3077ZM9.99998 8.39225C10.0833 8.39225 10.166 8.37975 10.2481 8.35475C10.3301 8.32975 10.4096 8.29546 10.4865 8.25188L17.6385 3.673C17.7526 3.6025 17.8333 3.51116 17.8808 3.39898C17.9282 3.28679 17.9423 3.16853 17.9231 3.04418C17.9102 2.81341 17.7974 2.64194 17.5846 2.52978C17.3718 2.41759 17.157 2.42752 16.9404 2.55957L9.99998 6.99998L3.05958 2.55957C2.84291 2.42752 2.62978 2.41695 2.42018 2.52785C2.21056 2.63873 2.09613 2.80763 2.0769 3.03455C2.05767 3.16917 2.07177 3.29417 2.1192 3.40955C2.16663 3.52493 2.2474 3.61275 2.3615 3.673L9.51345 8.25188C9.59037 8.29546 9.66985 8.32975 9.7519 8.35475C9.83395 8.37975 9.91664 8.39225 9.99998 8.39225Z",
    fill: "#A2ACD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelop);
export default __webpack_public_path__ + "static/media/envelop.53c24da6888fb07c5bb04203ca8eb876.svg";
export { ForwardRef as ReactComponent };